<template>
  <div class="pl-5 pr-5 mt-5">
    <div class="title">
      <v-icon class="indent pr-1">mdi-square-medium</v-icon>
      <span class="">{{ title }}</span>
    </div>

    <div class="font-weight-light mt-3">
      <p>
        KDS (Kitchen Display System) je aplikace, která řídí provoz kuchyně a expedice stravovacích zařízení,
        restaurací a jídelen. Zobrazuje v reálném čase informace o připravovaných pokrmech, časy připravy
        a expedice, informace o umístění pokrmů (stoly, zákazníci...). Aplikace je připravena pro použití
        na dotykových terminálech, je plně skinovatelná. Aplikace funguje na bázi klient-server,
        distibuuje informace na klienty (browsery) pomocí HTTP a TCP
        <a href="//en.wikipedia.org/wiki/WebSocket" target="_blank">
          <v-icon>mdi-open-in-new</v-icon>
          <span>WebSocket</span>
        </a>
        komunikačního protokolu.
      </p>

      <div class="subtitle-1">
        <span>Použité technologie:</span>
      </div>

      <ul class="mt-3">
        <li>PHP (Zend framework)</li>
        <li>TCP, UDP, Unix socket a WebSocket komunikace</li>
        <li>HTML</li>
        <li>jQuery</li>
        <li>AJAX</li>
      </ul>
    </div>

    <ImgCarousel :items="images" @click="click"></ImgCarousel>

  </div>
</template>

<script>
  import { call } from 'vuex-pathify';

  import ImgCarousel from "@/components/ImgCarousel";

  export default {
    name: "Kds",
    components: {
      ImgCarousel
    },
    data () {
      return {
        title: 'KDS – systém řízení kuchyně',
        images: [
          {
            src: '/img/refs/kds/01.png',
            description: 'Základní vzhled systému s objednávkami',
            alt: ''
          },
          {
            src: '/img/refs/kds/02.png',
            description: 'Ukázka drag & drop funcionality',
            alt: ''
          },
          {
            src: '/img/refs/kds/03.png',
            description: 'Ukázka průběhu komunikace aplikace se serverem',
            alt: ''
          },
          {
            src: '/img/refs/kds/04.png',
            description: 'Jiný vzhled aplikace',
            alt: ''
          },
        ]
      }
    },
    methods: {
      ...call('imgGallery', ['setItems', 'showGallery']),
      click (item) {
        this.showGallery({
          items: this.images,
          index: item.index,
          title: this.title
        });
      }
    }
  }
</script>

<style scoped>
  a {
    color: rgba(8, 113, 0, 0.87);
    text-decoration: none;
  }
  a:hover {
    border-bottom: 1px solid;
  }
  a i {
    font-size: 12px!important;
    margin-left: 2px;
    margin-right: 2px;
    margin-top: 1px;
  }
  .indent {
    margin-left: -7px;
    margin-top: -2px;
  }
</style>
